import { PackagePlan } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const PackageService = {
  createPackageService: async (bodyData) => {
    try {
      const payload = {
        ...PackagePlan.createPackage,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  checkoutPackageService: async (bodyData) => {
    try {
      const payload = {
        ...PackagePlan.checkoutPackage,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
